(function () {
  var IP = window.IPSections;
  if (!IP) return;

  var toArray = IP.toArray;
  var markReady = IP.markReady;
  var readFloat = IP.readFloat;

  function initStainShowcase(section) {
    if (!markReady(section, 'ready')) return;

    var tabs = section.querySelectorAll('[data-stain-tab]');
    var panels = section.querySelectorAll('[data-stain-panel]');

    function setActiveTab(targetId) {
      toArray(tabs).forEach(function (tab) {
        var isActive = tab.getAttribute('data-stain-tab') === targetId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      toArray(panels).forEach(function (panel) {
        var isActive = panel.getAttribute('data-stain-panel') === targetId;
        panel.classList.toggle('is-active', isActive);

        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    toArray(tabs).forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActiveTab(tab.getAttribute('data-stain-tab'));
      });
    });
  }
  IP.register('ip-stain-showcase', '[data-stain-showcase]', function (section) {
    initStainShowcase(section);
    IP.initReveal(section);
  });
})();
